const getContainer = function(element) {
  return element.closest("[data-process-groups-content]");
};
const fetchAndReplace = function(container, url, pushState = true) {
  const containerId = container.id;
  if (!containerId) {
    window.location.href = url;
    return;
  }
  fetch(url).then((response) => response.text()).then((html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = doc.getElementById(containerId);
    if (fresh) {
      container.innerHTML = fresh.innerHTML;
    } else {
      window.location.href = url;
    }
    if (pushState) {
      window.history.pushState({}, "", url);
    }
  }).catch(() => {
    window.location.href = url;
  });
};
const formUrl = function(form) {
  const params = new URLSearchParams(new FormData(form));
  return `${form.action}?${params}`;
};
document.addEventListener("change", (event) => {
  if (event.target.type !== "checkbox") {
    return;
  }
  const form = event.target.closest("[data-auto-submit-form]");
  if (!form) {
    return;
  }
  const parentId = event.target.dataset.parentCheckbox;
  if (parentId) {
    form.querySelectorAll(`input[data-parent-taxonomy="${parentId}"]`).forEach((ch) => {
      ch.checked = event.target.checked;
    });
  }
  const container = getContainer(form);
  if (container) {
    fetchAndReplace(container, formUrl(form));
  }
});
document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-remove-tag]");
  if (!button) {
    return;
  }
  const container = getContainer(button);
  if (!container) {
    return;
  }
  const form = container.querySelector("[data-auto-submit-form]");
  if (!form) {
    return;
  }
  const checkbox = form.querySelector(
    `input[name="taxonomy_ids[]"][value="${button.dataset.removeTag}"]`
  );
  if (checkbox) {
    checkbox.checked = false;
  }
  fetchAndReplace(container, formUrl(form));
});
document.addEventListener("click", (event) => {
  const link = event.target.closest(
    "[data-process-groups-content] .process-groups-filter-tab, [data-process-groups-content] .process-groups-pagination a"
  );
  if (!link || !link.href) {
    return;
  }
  event.preventDefault();
  const container = getContainer(link);
  if (container) {
    fetchAndReplace(container, link.href);
  }
});
window.addEventListener("popstate", () => {
  document.querySelectorAll("[data-process-groups-content]").forEach((container) => {
    fetchAndReplace(container, window.location.href, false);
  });
});
